export default function WordList({
  validWordsClone,
  validWords,
}) {
  return (
    <div className="text-center position-relative">
      <div className="wordboard">
        <img className='wordboard_img' src={`${process.env.PUBLIC_URL}/assets/images/puzzle/wordboard.png`} alt="WordBoard" />
      </div>
      <div className="board_btns">
        {validWordsClone.map((word) => {
          const found =
            !validWords.includes(word);

          return (

            <button
              key={word}
              className={`p-3 rounded-xl d-block font-bold w-100 ${found
                ? 'bg-green-500 text-dark'
                : 'bg-gray-100 text-gray-400'
                }`}
            >
              {found
                ? word
                : '-'.repeat(word.length)}
            </button>

          );
        })}
      </div>
    </div>
  );
}